import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css'
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css'
import {store,persistor} from './redux/store'
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { GlobalWorkerOptions } from 'pdfjs-dist/webpack';
GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.11.338/pdf.worker.min.js`;
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
          <App />
          </PersistGate>
      </Provider>
  
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
